import React from 'react';

import { filter } from 'lodash-es';
import styled from 'styled-components';

const AnchorLinks = styled.ul`
  list-style: none;
  border-top: 2px solid ${Styles.color.grey.five};
  border-bottom: 2px solid ${Styles.color.grey.five};
  margin: 1rem auto 2.5rem;
  padding: 1.5rem 0rem;
  width: 90%;
  max-width: 1100px;
  text-align: center;
  & > li {
    position: relative;
    display: inline-block;
    margin: 0.5rem 1rem;
    padding: 0;
    ${Styles.mobileSmall`
      display: block;
      margin: 1rem 0rem;
    `}
    & > a {
      display: inline-block;
      position: relative;
      color: inherit;
      text-decoration: none;
      &:hover::after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: ${Styles.color.black};
        }
      }
    }
  }
`;

const AnchorLinksWidget = props => {
  return (
    <AnchorLinks>
      {filter(props.widgets, ['_type', 'anchorWidget']).map(anchor => {
        return (
          <li key={anchor._key}>
            <a href={`#${anchor.anchorName?.locale.replace(/\s/g, '')}`}>
              {anchor.anchorName?.locale}
            </a>
          </li>
        );
      })}
    </AnchorLinks>
  );
};

export default AnchorLinksWidget;
